import { useAuth0 } from '@auth0/auth0-react';
import { Role } from 'src/@types/role';
import { useOrgs } from './query/orgHooks';
import { useCurrentOrgContext } from 'src/contexts/OrgContext';

export const useUserRole = (): { data: Role | undefined; isPending: boolean } => {
  const { user: auth0User, isLoading: auth0Loading } = useAuth0();
  const { data: usersOrgs, isPending: orgsLoading } = useOrgs({
    config: { enabled: !!auth0User },
  });
  const { orgId, mode } = useCurrentOrgContext();

  const loading = auth0Loading || orgsLoading;
  let role: Role | undefined;

  if (auth0User && auth0User['https://numinar.com/roles']?.[0] === 'admin') {
    role = Role.NuminarAdmin;
  } else if (mode === 'dt' && auth0User?.['https://numinar.com/roles']?.[0] === 'datatrust_admin') {
    role = Role.DTAdmin;
  } else if (
    auth0User &&
    (auth0User['https://numinar.com/roles']?.[0] === 'managed_canvass_coordinator' ||
      auth0User['https://numinar.com/roles']?.[0] === 'managed_calls_coordinator' ||
      auth0User['https://numinar.com/roles']?.[0] === 'managed_texts_coordinator' ||
      auth0User['https://numinar.com/roles']?.[0] === 'managed_mail_coordinator')
  ) {
    role = Role.ManagedOutreachCoordinator;
  } else {
    role = usersOrgs?.find((org) => org.id === orgId)?.user_org_role;
    if (!Object.values(Role).includes(role as Role)) {
      role = undefined;
    }
  }

  return {
    data: role,
    isPending: loading,
  };
};
